import { Box } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabPanelProps } from "../../types/helpers/types";
import { trackEventMatomo } from '../../helpers/matomo';
import AdmData from "./AdmData";
import HierarchyConfig from "./HierarchyConfig";
import Password from "./Password";
import Permissions from "./Permissions";
import NotificationConfig from "./Notification";
import Role from "./Role";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function SettingsTabs() {
  const { t } = useTranslation('translation');
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const tabs = ['perfil', 'senha', 'dados administrativos', 'hierarquia', 'notificações', 'permissões'];
    trackEventMatomo('configurações', 'click', 'aba', tabs[newValue]);
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs textColor="secondary" indicatorColor="secondary" value={value} onChange={handleChange} scrollButtons="auto" variant="scrollable">
          <Tab label={t('settingsPage.profile.title')} value={0} />
          <Tab label={t('settingsPage.password.title')} value={1} />
          <Tab label={t('settingsPage.data.title')} value={2} />
          <Tab label={t('settingsPage.hierarchy.title')} value={3} />
          <Tab label={t("notifications.newModificationModal.notificationConfig")} value={4} />
          <Tab label={t('settingsPage.permissions')} value={5} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Role />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Password />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AdmData />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <HierarchyConfig />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <NotificationConfig />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <Permissions />
      </CustomTabPanel>
    </>
  );
}
